import React from 'react';
import bannerImage from '../assets/banner/bg-banner7.jpg';
import brideImage from '../assets/banner/banner7-1.jpg';
import groomImage from '../assets/banner/banner7-2.jpg';
// import './Banner.css';

const Banner = () => {
  return (
    <section className="banner-section-seven">
      <div className="bg bg-image" style={{backgroundImage: `url(${bannerImage})`}}></div>

      <div className="flower-7 bounce-y"></div>
      <div className="flower-8 bounce-y"></div>
      <div className="auto-container">
        <div className="row">
          <div className="content-column col-xxl-8 col-xl-6 col-lg-12 col-md-12 col-sm-12 order-xl-3">
            <div className="inner-column">
              <div className="icon-color-2"></div>
              <span className="sub-title wow fadeInUp" data-wow-delay="300ms">Save the date</span>
              <h2 className="name wow fadeInUp" data-wow-delay="600ms">
                Alison <br />
                <span>&</span> <br />
                Rozia
              </h2>
              <div className="date wow fadeInUp" data-wow-delay="900ms">Sat<span>23</span> July</div>
              <div className="text wow fadeInUp" data-wow-delay="1200ms">
                ONE O'CLOCK IN THE AFTERNOON <br/> THE WHITE CHURCH
              </div>
            </div>
          </div>
          
          <div className="image-column col-xxl-2 col-xl-3 col-lg-6 col-md-6 col-sm-6">
            <div className="inner-column">
              <div className="image-box">
                <figure className="bride-img overlay-anim wow zoomIn">
                  <img src={brideImage} alt="Bride" />
                </figure>
              </div>
            </div>
          </div>
          
          <div className="image-column col-xxl-2 col-xl-3 col-lg-6 col-md-6 col-sm-6 order-lg-3">
            <div className="inner-column">
              <div className="image-box">
                <figure className="groom-img overlay-anim wow zoomIn" data-wow-delay="300ms">
                  <img src={groomImage} alt="Groom" />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;